// import React, { useEffect, useState } from "react";
// import LayoutNew from "../../components/newComponents/LayoutNew";
// import HeaderNew from "../../components/newComponents/HeaderNew";
// import MainLayout from "../../components/newComponents/MainLayout";
// import TabsNew from "../../components/newComponents/TabsNew";
// import Lottie from "lottie-react";
// import loginAnimation from "../../staticAnimations/loginAnimation.json";
// import classes from "./Login2.module.css";
// import { Box, TextField, Button, Typography } from "@mui/material";
// import Loader from "../../components/Loader";
// import { Link, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { baseURL, loginURL } from "../../api";
// import { setUserCredentials } from "../../slices/userSlice";
// import SearchBox from "../../components/newComponents/SearchBox";

// const Login2 = () => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const { user } = useSelector((state) => state.user);
//   const { open } = useSelector((state) => state.menu);

//   useEffect(() => {
//     if (user) {
//       navigate("/account");
//     }
//   }, [navigate]);

//   const submitHandler = async (e) => {
//     e.preventDefault();
//     try {
//       if (!username || !password) {
//         toast.error("Email or password fields cannot be empty");
//         return;
//       }
//       const data = { username, password };
//       setLoading(true);
//       const res = await axios.post(`${baseURL}${loginURL}`, data);
//       console.log(res);
//       dispatch(setUserCredentials(res.data));
//       setLoading(false);
//       navigate("/");
//       toast.success("Logged in successfully");
//     } catch (err) {
//       console.log(err);
//       setLoading(false);
//       toast.error(
//         err?.message ||
//           err?.response?.data?.response ||
//           err?.error ||
//           err?.response
//       );
//     }
//   };
//   return (
//     <LayoutNew>
//       <SearchBox />
//       <HeaderNew />
//       <MainLayout>
//         <TabsNew value={3} label="Login" />
//         {/* <div className={classes.login_text}>
//           <h3 className={classes.text}>Login to play the quiz</h3>
//         </div> */}
//         <div className={classes.container}>
//           <div className={classes.animation_container}>
//             <Lottie
//               animationData={loginAnimation}
//               loop={true}
//               autoplay={true}
//               className={classes.animation}
//             />
//           </div>
//           <div className={classes.login_container}>
//             <form className={classes.form_signup} onSubmit={submitHandler}>
//               <div className={classes.input_group}>
//                 <input
//                   type="number"
//                   value={username}
//                   onChange={(e) => setUsername(e.target.value)}
//                   placeholder="Number"
//                 />
//                 <i className="fa-solid fa-user"></i>
//               </div>
//               <div className={classes.input_group}>
//                 <input
//                   type="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Password"
//                 />
//                 <i className="fa-solid fa-lock"></i>
//               </div>
//               <button className={classes.form_btn} type="submit">
//                 Login
//               </button>
//               {loading && <Loader />}
//               <div
//                 className={classes.form_link}
//                 onClick={() => navigate("/signup")}
//               >
//                 <Link to="/signup"> Sign up , if you are not a User</Link>
//               </div>
//             </form>
//           </div>
//         </div>
//       </MainLayout>
//     </LayoutNew>
//   );
// };

// export default Login2;


// import React, { useEffect, useState } from "react";
// import LayoutNew from "../../components/newComponents/LayoutNew";
// import HeaderNew from "../../components/newComponents/HeaderNew";
// import MainLayout from "../../components/newComponents/MainLayout";
// import TabsNew from "../../components/newComponents/TabsNew";
// import Lottie from "lottie-react";
// import loginAnimation from "../../staticAnimations/loginAnimation.json";
// import classes from "./Login2.module.css";
// import { Box, TextField, Button, Typography } from "@mui/material";
// import Loader from "../../components/Loader";
// import { Link, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { baseURL, loginURL } from "../../api";
// import { setUserCredentials } from "../../slices/userSlice";
// import SearchBox from "../../components/newComponents/SearchBox";

// const Login2 = () => {
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const { user } = useSelector((state) => state.user);

//   useEffect(() => {
//     if (user) {
//       navigate("/account");
//     }
//   }, [navigate]);

//   const submitHandler = async (e) => {
//     e.preventDefault();
//     try {
//       const username = "12345";  // Static username
//       const password = "12345";  // Static password

//       setLoading(true);
//       const data = { username, password };
//       const res = await axios.post(`${baseURL}${loginURL}`, data);
//       console.log(res);
//       dispatch(setUserCredentials(res.data));
//       setLoading(false);
//       navigate("/");
//       toast.success("Logged in successfully");
//     } catch (err) {
//       console.log(err);
//       setLoading(false);
//       toast.error(
//         err?.message ||
//           err?.response?.data?.response ||
//           err?.error ||
//           err?.response
//       );
//     }
//   };

//   return (
//     <LayoutNew>
//       <SearchBox />
//       <HeaderNew />
//       <MainLayout>
//         <TabsNew value={3} label="Login" />
//         <div className={classes.container}>
//           <div className={classes.animation_container}>
//             <Lottie
//               animationData={loginAnimation}
//               loop={true}
//               autoplay={true}
//               className={classes.animation}
//             />
//           </div>
//           <div className={classes.login_container}>
//             <form className={classes.form_signup} onSubmit={submitHandler}>
//               <div className={classes.input_group}>
//                 <input
//                   type="number"
//                   value="12345"  // Static username input
//                   readOnly
//                   placeholder="Number"
//                 />
//                 <i className="fa-solid fa-user"></i>
//               </div>
//               <div className={classes.input_group}>
//                 <input
//                   type="password"
//                   value="12345"  // Static password input
//                   readOnly
//                   placeholder="Password"
//                 />
//                 <i className="fa-solid fa-lock"></i>
//               </div>
//               <button className={classes.form_btn} type="submit">
//                 Login
//               </button>
//               {loading && <Loader />}
//               <div
//                 className={classes.form_link}
//                 onClick={() => navigate("/signup")}
//               >
//                 <Link to="/signup"> Sign up , if you are not a User</Link>
//               </div>
//             </form>
//           </div>
//         </div>
//       </MainLayout>
//     </LayoutNew>
//   );
// };

// export default Login2;


import React, { useEffect, useState } from "react";
import LayoutNew from "../../components/newComponents/LayoutNew";
import HeaderNew from "../../components/newComponents/HeaderNew";
import MainLayout from "../../components/newComponents/MainLayout";
import TabsNew from "../../components/newComponents/TabsNew";
import Lottie from "lottie-react";
import loginAnimation from "../../staticAnimations/loginAnimation.json";
import classes from "./Login2.module.css";
import { Box, TextField, Button, Typography } from "@mui/material";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { baseURL, loginURL ,registerURL} from "../../api";
import { setUserCredentials } from "../../slices/userSlice";
import SearchBox from "../../components/newComponents/SearchBox";
import Cookies from 'js-cookie'
const Login2 = ({status}) => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (user) {
      navigate("/account");
    }
  }, [navigate, user]);

useEffect(() => {
  const username = Cookies.get("msisdn");
  const password = Cookies.get("msisdn");

  const autoRegisterAndLogin = async () => {
    try {
      setLoading(true);

      // Step 1: Register
      const registerRes = await axios.post(`${baseURL}${registerURL}`, {
        username,
        password,
      });
      console.log("Register Response:", registerRes.data);

      // Step 2: Login
      const loginRes = await axios.post(`${baseURL}${loginURL}`, {
        username,
        password,
      });
      console.log("Login Response:", loginRes.data);

      dispatch(setUserCredentials(loginRes.data));
      // toast.success("Logged in successfully");
      navigate("/");
    } catch (err) {
      console.error("Error:", err?.response?.data || err.message);
      toast.error(
        err?.response?.data?.message ||
        err?.response?.data?.response ||
        err?.message ||
        "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  autoRegisterAndLogin();
}, [dispatch, navigate]);

  
  // useEffect(() => {
  //   const username = Cookies.get('msisdn'); // Static username
  //   const password = Cookies.get('msisdn'); // Static password

  //   // Call submitHandler immediately after values are set
  //   const submitHandler = async () => {
  //     try {
  //       setLoading(true);
  //       const data = { username, password };
  //       const res = await axios.post(`${baseURL}${loginURL}`, data);
  //       console.log(res);
  //       dispatch(setUserCredentials(res.data));
  //       setLoading(false);
  //       navigate("/");
  //       toast.success("Logged in successfully");
  //     } catch (err) {
  //       console.log(err);
  //       setLoading(false);
  //       toast.error(
  //         err?.message ||
  //           err?.response?.data?.response ||
  //           err?.error ||
  //           err?.response
  //       );
  //     }
  //   };

  //   submitHandler(); // Automatically trigger login
  // }, [dispatch, navigate]);

  return (
    <LayoutNew>
      <SearchBox />
      <HeaderNew status={status}/>
      <MainLayout>
        <TabsNew value={3} label="Login" />
        <div className={classes.container}>
          <div className={classes.animation_container}>
            <Lottie
              animationData={loginAnimation}
              loop={true}
              autoplay={true}
              className={classes.animation}
            />
          </div>
          <div className={classes.login_container}>
            <form className={classes.form_signup}>
              <div className={classes.input_group}>
                <input
                  type="number"
                  value="12345" // Static username input
                  readOnly
                  placeholder="Number"
                />
                <i className="fa-solid fa-user"></i>
              </div>
              <div className={classes.input_group}>
                <input
                  type="password"
                  value="12345" // Static password input
                  readOnly
                  placeholder="Password"
                />
                <i className="fa-solid fa-lock"></i>
              </div>
              {loading && <Loader />}
              <div
                className={classes.form_link}
                onClick={() => navigate("/signup")}
              >
                <Link to="/signup"> Sign up, if you are not a User</Link>
              </div>
            </form>
          </div>
        </div>
      </MainLayout>
    </LayoutNew>
  );
};

export default Login2;

